// extracted by mini-css-extract-plugin
export var grid = "Services-module--grid--0SVsv";
export var serviceCard = "Services-module--serviceCard--QaF2l";
export var services = "Services-module--services--qVWcd";